// import './vendor';
import year from './components/year';
import lang from './components/lang';
import board from './components/board';

document.addEventListener('DOMContentLoaded', () => {
	year.init();
	lang.init();
	board.init();
});
